<template>
  <div class="dept">
    <el-input
      class="search-dept"
      prefix-icon="el-icon-search"
      v-model.trim="departmentName"
      @input="searchDep"
      size="small"
      placeholder="部门名称"
    />
    <el-tree
      class="tree-dept"
      ref="tree"
      :props="props"
      :data="deptTreeData"
      node-key="id"
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      highlight-current
      @node-click="nodeClick"
    >
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    deptTreeData: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    defaultId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      props: {
        label: "name",
        children: "children",
      },
      departmentName: "",
    };
  },
  watch: {
    defaultId: {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(val);
        });
      },
    },
  },
  updated() {
    let doms = document.getElementsByClassName("el-tree-node__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    nodeClick(data) {
      this.$emit("select", { deptId: data.id });
    },
    searchDep(val) {
      this.$refs.tree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.dept {
  .search-dept {
    font-size: 12px;
  }
  /deep/ .el-input__inner::placeholder {
    font-size: 12px;
  }
  .tree-dept {
    margin-top: 10px;
    background-color: #f4f8fb;
    color: #51627d;
    font-size: 12px;
  }
}
/deep/ .el-tree-node__content {
  height: auto;
}
</style>
